// import { GrainsInputSchema } from '@aginnovationaustralia/emissions-calculators4.0.1/calculators';
// import {  } from '@aginnovationaustralia/emissions-calculators4.0.1/grains/types/input';
import { Processor, ProcessorResponse } from './types';

// function flattenFullCamReadyAreas(areas: FullCAMOutputs['areas']): {
//   activities: NonNullable<FullCAMOutputs['areas'][number]['activities']>;
//   burning: NonNullable<FullCAMOutputs['areas'][number]['burning']>;
//   perennialCrops: NonNullable<FullCAMOutputs['areas'][number]['perennialCrops']>;
// } {
//   return {
//     activities: areas.flatMap((area) => area.activities ?? []),
//     burning: areas.flatMap((area) => area.burning ?? []),
//     perennialCrops: areas.flatMap((area) => area.perennialCrops ?? []),
//   };
// }

// const handleFullCAMLandUse = (calculatorInput: unknown): FullCAMResult<Record<string, unknown>> => {
//   if (typeof calculatorInput !== 'object' || calculatorInput === null) {
//     return Result.err({
//       step: 'parse-input',
//       message: 'Calculator is not an object',
//       error: new Error('Calculator is not an object'),
//     });
//   }

//   if (!('landUse' in calculatorInput) || calculatorInput.landUse === undefined) {
//     return Result.ok(calculatorInput as Record<string, unknown>);
//   }

//   const { landUse } = calculatorInput;

//   const readyParsed = FullCAMOutputsSchema.safeParse(landUse);
//   if (readyParsed.success) {
//     // Use the raw input — parsed output has unit containers we must not forward
//     const readyLandUse = landUse as FullCAMOutputs;
//     return Result.ok({
//       ...calculatorInput,
//       landUse: flattenFullCamReadyAreas(readyLandUse.areas),
//     });
//   }

//   const upgradeParsed = FullCAMInputsSchema.safeParse(landUse);
//   if (!upgradeParsed.success) {
//     const claimedUpgrade =
//       typeof landUse === 'object' && landUse !== null && 'fullcamMode' in landUse && landUse.fullcamMode === 'upgrade';
//     const parseError = claimedUpgrade ? upgradeParsed.error : readyParsed.error;
//     return Result.err({
//       step: 'parse-input',
//       message: parseError.message,
//       error: parseError,
//     });
//   }

//   // NOTE: If the user tries to pass land use areas to upgrade with the FullCAM batch API,
//   // just skip them and return an empty array
//   const packageLandUse = generateLulucfInput([]);

//   return Result.ok({ ...calculatorInput, landUse: packageLandUse });
// };
/**
 * 4.0.1-beta.1's main/browser entry side-imports the Node execution environment
 * (mixpanel → buffer → `global is not defined` in the browser). Import calculator
 * subpaths instead until that package bug is fixed.
 */
// const calculators = {
//   grains: {
//     schema: GrainsInputWithFullCAMSchema, // Should be GrainsInputSchema, but that's not exported currently
//     calculate: calculateGrains,
//   },
// } as const;

// type CalculatorName = keyof typeof calculators;

// function isValidCalculatorName(name: string): name is CalculatorName {
//   return name in calculators;
// }

export const calc400: Processor = (_calculatorName: string, _input: unknown): ProcessorResponse => {
  return {
    body: { error: 'This version is not able to execute calculators yet' },
    status: 404,
  };
  // try {
  //   if (!isValidCalculatorName(calculatorName)) {
  //     return {
  //       body: { error: `Calculator ${calculatorName} not found` },
  //       status: 404,
  //     };
  //   }

  //   const { calculate } = calculators[calculatorName];

  //   const inputWithProcessedLandUse = handleFullCAMLandUse(input);

  //   if (inputWithProcessedLandUse.isErr) {
  //     return {
  //       body: {
  //         status: 'INVALID_INPUT',
  //         // issues: inputWithProcessedLandUse.error.issues,
  //         message: inputWithProcessedLandUse.error.message,
  //       },
  //       status: 422,
  //     };
  //   }

  //   const validated = inputWithProcessedLandUse.value;

  // TODO: We need to export GrainsInputSchema from the browser export key
  // const validated = validateCalculatorInput(schema, inputWithProcessedLandUse);
  // if (!validated.valid) {
  //   return {
  //     body: {
  //       status: 'INVALID_INPUT',
  //       issues: validated.issues,
  //       message: validated.message,
  //     },
  //     status: 422,
  //   };
  // }

  //   const emissions = calculate(validated, { organisation: 'AIA doc site' });
  //   return {
  //     body: emissions,
  //     status: 200,
  //   };
  // } catch (error) {
  //   console.error(`Error calculating ${calculatorName}:`, error);
  //   return {
  //     body: { error: `Error when processing ${calculatorName} calculator: ${error}` },
  //     status: 500,
  //   };
  // }
};
